<template>
  <vxe-modal
    ref="modal"
    v-model="formVisible"
    :title="`${DocumentStatus}邮寄`"
    width="80%"
    height="90%"
    @show="showModal"
  >
    <div class="formContainer">
      <div class="leftFormContainer">
        <el-form ref="FormRef" size="mini" :rules="rules" :model="form">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="寄件人" prop="sender">
                <el-input placeholder="选择" v-model="form.sender" v-readonly clearable :disabled="isDisabled">
                  <i style="cursor: pointer;" slot="suffix" class="el-icon-search" @click="handleSelect"></i>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="寄件日期" prop="ship_date">
                <el-date-picker
                  type="date"
                  placeholder="输入"
                  value-format="yyyy-MM-dd"
                  v-model="form.ship_date"
                  :disabled="isDisabled"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="寄件内容" prop="contribution_details">
                <el-input placeholder="输入" v-model="form.contribution_details" :disabled="isDisabled" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="快递公司" prop="courier_company">
                <!-- <el-input placeholder="输入" v-model="form.courier_company" /> -->
                <el-autocomplete
                  v-model="form.courier_company"
                  :fetch-suggestions="querySearchCourier_company"
                  placeholder="输入"
                  clearable
                  :disabled="isDisabled"
                ></el-autocomplete>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="是否加急" prop="is_expedited">
                <el-select clearable v-model="form.is_expedited" :placeholder="'选择'" :disabled="isDisabled">
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="收件单位" prop="receiving_company">
                <el-autocomplete
                  v-model="form.receiving_company"
                  :fetch-suggestions="querySearchReceiving_company"
                  placeholder="输入"
                  clearable
                  @select="handleSelectReceiving_company"
                  :disabled="isDisabled"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="收件人" prop="recipient">
                <el-autocomplete
                  v-model="form.recipient"
                  :fetch-suggestions="querySearchRecipient"
                  placeholder="输入"
                  clearable
                  @select="handleSelectRecipient"
                  :disabled="isDisabled"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.document_status === 9">
              <el-form-item label="快递单号" prop="express_number">
                <el-input
                  placeholder="输入"
                  v-model="form.express_number"
                  :disabled="
                    isDisabled &&
                      !(
                        this.form.id > 0 &&
                        this.form.document_status === 9 &&
                        this.$store.state.userInfo.name === '连燕燕'
                      )
                  "
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="rightFormContainer">
        <FileList :ID="id" :isDisabled="isDisabled" ref="FileListRef" vuePath="MailRecords" />
      </div>
    </div>

    <DetailModalBtnMailRecords
      ref="DetailModalBtnVueRef"
      menuPath="MailRecords"
      :parentData="this"
      @handleClick="handleClickBtn"
    />

    <!-- 选择用户 -->
    <EmployeeSelect ref="EmployeeSelectRef" @sureBackPerson="sureBackPerson" :isMultiple="false" />
  </vxe-modal>
</template>
<script>
import FileList from '@/components/Form/FileList.vue'
import DetailModalBtnMailRecords from '@/components/common/DetailModalBtn.vue'
import { getState } from '../../utils/state'
import EmployeeSelect from '../../components/Modal/Employee/EmployeeSelect.vue'

export default {
  components: {
    FileList,
    DetailModalBtnMailRecords,
    EmployeeSelect
  },
  data() {
    return {
      id: -1,
      // 表单
      form: {
        id: 0,
        creator_id: 0,
        creator: '',
        createTime: '',
        dept_name: '',
        report_approve_id: 0,
        sender: '',
        ship_date: '',
        contribution_details: '',
        courier_company: '',
        is_expedited: '',
        recipient: '',
        receiving_company: '',
        document_status: 0,
        express_number: '',
        last_modify_time: ''
      },
      rules: {
        sender: [
          { required: true, message: '请选择寄件人', trigger: 'change' },
          {
            min: 0,
            max: 32,
            message: '长度在 0 到 32 个字符',
            trigger: 'change'
          }
        ],
        ship_date: [{ required: true, message: '请输入寄件日期', trigger: 'change' }],
        contribution_details: [
          { required: true, message: '请输入寄件内容', trigger: 'change' },
          {
            min: 0,
            max: 512,
            message: '长度在 0 到 512 个字符',
            trigger: 'change'
          }
        ],
        courier_company: [
          { required: true, message: '请输入快递公司', trigger: 'change' },
          {
            min: 0,
            max: 128,
            message: '长度在 0 到 128 个字符',
            trigger: 'change'
          }
        ],
        is_expedited: [],
        recipient: [
          { required: true, message: '请输入收件人', trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '长度在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        express_number: [
          {
            min: 0,
            max: 64,
            message: '长度在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        receiving_company: [
          { required: true, message: '请输入收件单位', trigger: 'change' },
          {
            min: 0,
            max: 128,
            message: '长度在 0 到 128 个字符',
            trigger: 'change'
          }
        ]
      },
      // 下拉框
      ComBoxItems: {},
      formVisible: false,

      showMoney: true,
      // 是否禁用编辑
      isDisabled: false,
      // 联想下拉集合
      combobox: {
        recipient: [],
        receiving_company: []
      }
    }
  },
  methods: {
    // 保存快递单号
    async saveExpressNo() {
      const { data: res } = await this.$http.put('/Finance/Mail_records/express-number', [
        {
          id: this.form.id,
          express_number: this.form.express_number
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      this.$emit('updateData')

      this.BindText()
      this.$message.success(this.messageConfig.save.success)
    },
    // 确认选择收件人
    handleSelectRecipient(item) {
      if (!this.form.receiving_company) {
        this.form.receiving_company = item.code
      }
    },
    // 确认选择收件单位
    handleSelectReceiving_company(item) {
      if (!this.form.recipient) {
        const filterItems = this.combobox.recipient.filter(i => i.code === item.value)
        if (filterItems.length === 1) {
          this.form.recipient = filterItems[0].value
        }
      }
    },
    // 联想下拉 - 收件单位
    querySearchReceiving_company(queryString, cb) {
      const results = queryString
        ? this.combobox.receiving_company.filter(item => String(item.value).includes(queryString))
        : this.combobox.receiving_company
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    // 联想下拉 - 收件人
    querySearchRecipient(queryString, cb) {
      let results = []
      const combobox = this.form.receiving_company
        ? this.combobox.recipient.filter(item => item.code === this.form.receiving_company)
        : this.combobox.recipient

      results = queryString ? combobox.filter(item => String(item.value).includes(queryString)) : combobox

      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    // 绑定下拉框
    async BindComBox() {
      this.combobox.recipient = []
      this.combobox.receiving_company = []

      const { data: selectRes } = await this.$http.get('/Finance/Mail_records/select-item')
      if (selectRes.isSuccess) {
        for (let item of selectRes.data) {
          if (item.code === 'receiving_company') {
            this.combobox.receiving_company.push({
              label: item.name,
              value: item.value
            })
          } else if (item.comments === '收件人') {
            this.combobox.recipient.push({
              code: item.code,
              label: item.name,
              value: item.value
            })
          }
        }
      }
    },
    // 调用审批接口
    async sureReview(flag = false, approve_opinions = '') {
      const { data: res } = await this.$http.put('/Finance/Mail_records/audit', [
        {
          id: this.id,
          manager_review: flag,
          approve_opinions
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用撤销审核
    async sureUnReview(flag = false) {
      const { data: res } = await this.$http.put('/Finance/Mail_records/unaudit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用拒绝接口
    async sureObsolete() {
      const { data: res } = await this.$http.put('/Finance/Mail_records/obsolete', [
        {
          id: this.id,
          manager_review: false
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 取消审核
    unReview() {
      this.$confirm('是否确认取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 领导/总经理审批
    leaderReview() {
      this.$confirm('是否确认审批通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 领导/总经理审批
    refuse() {
      this.$confirm('是否确认拒绝?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureObsolete()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 点击底部按钮
    handleClickBtn(code) {
      switch (code) {
        case 'save':
          this.save()
          break
        case 'del':
          this.del()
          break
        case 'unReview':
          this.unReview()
          break
        case 'faReview':
        case 'financialReview':
        case 'managerReview':
        case 'leaderReview':
          this.leaderReview()
          break
        case 'refuse':
          this.refuse()
          break
        case 'close':
          this.formVisible = false
          break
        case 'saveExpressNo':
          this.saveExpressNo()
          break
      }
    },
    querySearchCourier_company(queryString, cb) {
      const selectOptions = [
        {
          label: '京东物流',
          value: '京东物流'
        },
        {
          label: '顺丰速运',
          value: '顺丰速运'
        },
        {
          label: '邮政快递',
          value: '邮政快递'
        },
        {
          label: '韵达快递',
          value: '韵达快递'
        },
        {
          label: '中通快递',
          value: '中通快递'
        },
        {
          label: '圆通速递',
          value: '圆通速递'
        },
        {
          label: '申通快递',
          value: '申通快递'
        },
        {
          label: '百世快递',
          value: '百世快递'
        }
      ]

      const results = queryString
        ? selectOptions.filter(item => String(item.value).includes(queryString))
        : selectOptions
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    // 选择人员
    handleSelect() {
      if (!this.isDisabled) {
        this.$refs.EmployeeSelectRef.openModal(this.form.users_names)
      }
    },
    // 选择完成后
    sureBackPerson(person) {
      this.form.sender = person

      // this.dayCountChange()
    },
    // 获取附件
    getFileList() {
      this.$refs.FileListRef.init()
    },
    // 打开模态窗
    openModal(id = 0) {
      this.id = id

      if (!this.id) {
        this.form = {
          id: 0,
          creator_id: 0,
          creator: '',
          createTime: '',
          dept_name: '',
          report_approve_id: 0,
          sender: '',
          ship_date: '',
          contribution_details: '',
          courier_company: '',
          is_expedited: '',
          recipient: '',
          receiving_company: '',
          document_status: 0,
          last_modify_time: ''
        }
      }

      this.BindComBox()

      this.$nextTick(() => {
        this.formVisible = true
      })
    },
    async validEnter() {
      const that = this
      let flag = true
      await that.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )

      if (!flag) {
        that.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 保存
    save() {
      this.validEnter().then(async result => {
        if (result) {
          if (this.id && this.id > 0) {
            this.update()
          } else {
            this.add()
          }
        }
      })
    },
    // 获取数据
    async BindText() {
      const that = this
      if (that.id > 0) {
        const { data: res } = await that.$http.get('/Finance/Mail_records', {
          params: {
            id: that.id
          }
        })
        if (res.isSuccess) {
          that.form = res.data
        }
      } else {
        this.form.ship_date = this.ykDateFormat('yyyy-MM-dd', new Date())
        // 用户信息赋值
        this.form.sender = this.$store.state.userInfo.name

        this.form.is_expedited = '否'

        this.form.creator_id = this.$store.state.userInfo.userId
        this.form.creator = this.$store.state.userInfo.name
        this.form.createTime = this.ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date())
      }
      that.$nextTick(() => {
        that.$refs.FormRef.clearValidate()

        if (this.form.document_status !== 0 || this.form.creator_id !== this.$store.state.userInfo.userId) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      })
    },
    // 新增
    async add() {
      const that = this
      let form = { ...that.form }
      form = that.removeObjectNull(form)
      const { data: res } = await that.$http.post('/Finance/Mail_records', form)
      if (res.isSuccess) {
        that.id = res.data
        that.$emit('updateData')

        this.$refs.FileListRef.handleUploadCacheFileToDB() // 提交缓存附件

        that.BindText()
        that.$message.success(that.messageConfig.save.success)
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    // 更新
    async update() {
      const that = this
      let form = { ...that.form }
      form = that.removeObjectNull(form)
      const { data: res } = await that.$http.put('/Finance/Mail_records', form)
      if (res.isSuccess) {
        that.$message.success(that.messageConfig.save.success)
        that.$emit('updateData')

        that.BindText()
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    // 删除
    del() {
      const that = this
      this.$confirm('此操作将永久删除该单据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await that.$http.delete('/Finance/Mail_records', {
          data: {
            id: that.id
          }
        })
        if (res.isSuccess) {
          that.$message.success(that.messageConfig.del.success)
          that.formVisible = false

          that.$emit('updateData')
        } else {
          that.$message.error(res.errorMessage)
        }
      })
    },
    // 提交缓存文件
    submitCacheFileToServer() {
      // this.$refs.FileListRef.handleUploadCacheFileToDB()
    },
    // 大写金额转换
    convertCurrency(amount) {
      if (amount == null || amount == '') {
        return ''
      }
      return this.amountLtoU(amount)
    },
    showModal() {
      this.BindText()

      this.getFileList()
    }
  },
  computed: {
    // 获取状态
    DocumentStatus() {
      if (this.id === 0) {
        return ''
      }

      return `[${getState(this.form, 'MailRecords')}] `
    }
  }
}
</script>
<style lang="less" scoped>
@rightFormContainerWidth: 250px;

.bottomBtns {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.formContainer {
  height: calc(100% - 40px - 10px - 31px);
  display: flex;
  flex-wrap: wrap;
}
.el-form-item {
  // margin: 0px !important;
  width: 100%;
  .el-input,
  .el-select,
  .el-date-picker {
    width: 100%;
  }
}
.leftFormContainer {
  height: 100%;
  width: calc(100% - @rightFormContainerWidth);

  box-sizing: border-box;
  padding: 0 10px 10px 10px;

  overflow: auto;

  /* 修改滚动条的宽度和颜色 */
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #999;
  }

  /* 鼠标悬停时滚动条 thumb 的颜色 */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #888;
  }
}
.rightFormContainer {
  height: 100%;
  width: @rightFormContainerWidth;
  box-sizing: border-box;
  padding: 0 10px;
}
.el-autocomplete {
  width: 100%;
}
.el-autocomplete {
  width: 100%;
}
</style>
